// utils/formStatus.ts
export const hasSubmittedInquiry = () =>
  localStorage.getItem("inquirySubmitted") === "true";

export const markInquirySubmitted = () =>
  localStorage.setItem("inquirySubmitted", "true");

export const isInquirySubmitted = (): boolean => {
  return localStorage.getItem("inquirySubmitted") === "true";
};
